import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ui } from "@/lib/ui";

export const ListEditor = ({ label, items, fields, blank, onChange, testId }) => {
  const update = (i, k, v) => onChange(items.map((it, idx) => (idx === i ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-3" data-testid={testId}>
      <p className={ui.label}>{label}</p>
      {items.map((it, i) => (
        <div key={i} className="border border-slate-800 bg-slate-950/60 p-3 grid gap-2 relative pr-10">
          {fields.map((f) => f.multiline ? (
            <Textarea key={f.key} rows={2} placeholder={f.placeholder} value={it[f.key]} onChange={(e) => update(i, f.key, e.target.value)} className={ui.input} data-testid={`${testId}-${i}-${f.key}`} />
          ) : (
            <Input key={f.key} placeholder={f.placeholder} value={it[f.key]} onChange={(e) => update(i, f.key, e.target.value)} className={`h-10 ${ui.input}`} data-testid={`${testId}-${i}-${f.key}`} />
          ))}
          <button type="button" onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="absolute top-3 right-3 text-slate-500 hover:text-[#FF2A2A]" data-testid={`${testId}-${i}-remove`} aria-label="Remove">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
      <Button type="button" variant="ghost" onClick={() => onChange([...items, { ...blank }])} className="rounded-none font-mono text-xs uppercase text-cyan-300 hover:bg-cyan-950/40" data-testid={`${testId}-add`}>
        <Plus className="w-4 h-4 mr-1" />Add
      </Button>
    </div>
  );
};

export const TagEditor = ({ label, items, onChange, testId }) => (
  <div className="space-y-1.5">
    <label className={`block ${ui.label}`}>{label} <span className="normal-case tracking-normal text-slate-600">(comma separated)</span></label>
    <Input
      value={items.join(", ")}
      onChange={(e) => onChange(e.target.value.split(",").map((s) => s.trimStart()))}
      onBlur={() => onChange(items.map((s) => s.trim()).filter(Boolean))}
      className={`h-11 ${ui.input}`}
      data-testid={testId}
    />
  </div>
);
